import PropTypes from 'prop-types';

import { clsx } from '../../utils/clsx';
import styles from './LinkPreviewEmbed.module.css';

const getSiteName = (siteName, url) => {
  if (siteName) return siteName;
  if (!url) return '';
  try {
    const hostname = new URL(url).hostname.replace(/^www\./i, '');
    return hostname;
  } catch (err) {
    return '';
  }
};

const LinkPreviewEmbed = ({
  url,
  imageUrl,
  title,
  description,
  siteName,
  className,
  bodyClassName,
  imageClassName,
}) => {
  const finalSiteName = getSiteName(siteName, url);
  const Wrapper = url ? 'a' : 'article';
  const wrapperProps = url
    ? {
        href: url,
        target: '_blank',
        rel: 'noopener noreferrer nofollow',
      }
    : {};

  return (
    <Wrapper className={clsx(styles.embed, className)} {...wrapperProps}>
      <div className={clsx(styles.media, imageClassName)} aria-hidden={!imageUrl}>
        {imageUrl ? <img src={imageUrl} alt="" /> : <div className={styles.placeholder}>🔗</div>}
      </div>
      <div className={clsx(styles.body, bodyClassName)}>
        {finalSiteName ? <span className={styles.site}>{finalSiteName}</span> : null}
        {title ? <h3 className={styles.title}>{title}</h3> : null}
        {description ? <p className={styles.description}>{description}</p> : null}
      </div>
    </Wrapper>
  );
};

LinkPreviewEmbed.propTypes = {
  url: PropTypes.string,
  imageUrl: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  siteName: PropTypes.string,
  className: PropTypes.string,
  bodyClassName: PropTypes.string,
  imageClassName: PropTypes.string,
};

export default LinkPreviewEmbed;
